const Support = () => import('@/pages/Support');


export default {
  component: Support,
  path: '/support',
  redirect: '/',
  // children: [
  //   { path: '' },
  //   { path: '' },
  //   { path: '' }
  // ]
}
